import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';

export interface IUserRoleState {
    userRoles: string[];
}

/**
 * UserRole - action input
 */
export class UserRoleInput implements IActionInput {
    public getCacheKey = () => `UserRoleState`;
    public getCacheObjectType = () => 'UserRoleState';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * UserRole - action
 */
export async function userRoleAction(input: UserRoleInput, ctx: IActionContext): Promise<IUserRoleState> {
    return { userRoles: [] };
}

/**
 * UserRole - create new input for create action
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new UserRoleInput();
};

/**
 * UserRole - create action
 */
export default createObservableDataAction<IUserRoleState>({
    action: <IAction<IUserRoleState>>userRoleAction,
    input: createInput
});
